// Use current hostname for Production
export const WEBSITE_URL = "https://" + window.location.hostname;
